'use client';

import React, { FC, memo, PropsWithChildren } from 'react';
import { MainSplashScreen } from '@/components/Splash';
import VerifyPasscode from '@/modules/auth/components/PasscodeActions/VerifyPasscode';
import { useHasAuthenticator } from '@/modules/auth/hooks/Authenticator';
import { useIsNeedVerifyPasscodeListener } from '@/modules/auth/hooks/Passcode';

interface IPasscodeGuardContainerProps extends PropsWithChildren<{}> {}

const PasscodeGuardContainer: FC<IPasscodeGuardContainerProps> = memo(
  ({ children }) => {
    //prefetch
    useHasAuthenticator();

    const {
      isNeedVerifyPasscode,
      handleVerify,
      isLoading,
      isPasscodeNeedHighSecurity,
    } = useIsNeedVerifyPasscodeListener();

    const shouldRenderChildren: boolean =
      !isNeedVerifyPasscode || !isPasscodeNeedHighSecurity;

    return (
      <>
        {isLoading ? (
          <MainSplashScreen />
        ) : (
          <>
            {isNeedVerifyPasscode && (
              <VerifyPasscode onSuccess={() => handleVerify()} />
            )}
            {shouldRenderChildren && children}
          </>
        )}
      </>
    );
  }
);

PasscodeGuardContainer.displayName = 'PasscodeGuardContainer';

export default PasscodeGuardContainer;
